var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// ../~/fbjs/~/core-js/library/modules/$.uid.js
// module id = 349
// module chunks = 17